import { API_BASE_PATH } from '@/config';
import { axios } from '@/lib/axios';

export const logout = async (): Promise<void> => axios.post(`${API_BASE_PATH}/logout`);
